import React from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";

export const DialogHistoricoHospitalized = ({
    visible,
    onHide,
    data = [],
    patientName
}) => {

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };


    const dateBody = (rowData) => {

        if (!rowData?.created_at) {
            return "N/D";
        }

        return moment(rowData.created_at).format(
            "DD/MM/YYYY HH:mm"
        );
    };


    const commentBody = (rowData) => {
        return (
            <div
                style={{
                    textAlign: "left",
                    whiteSpace: "normal",
                    lineHeight: "1.5"
                }}
            >
                {rowData?.comment || "Sin comentario"}
            </div>
        );
    };


    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            draggable={false}
            modal={true}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">

                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="pi pi-history"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Histórico de hospitalizaciones
                                {patientName && (
                                    <span> - {patientName}</span>
                                )}
                            </div>

                            <div
                                style={{
                                    fontSize: "11px",
                                    opacity: ".7"
                                }}
                            >
                                {data.length} registros encontrados
                            </div>
                        </div>

                    </div>

                </div>
            }
            className="Global-dialog Global-blue Global-medium "
        >
            <br />

            <DataTable
                value={data}
                paginator={data.length > 8}
                rows={8}
                stripedRows
                showGridlines
                className="p-datatable-sm shadow-sm"
                rowsPerPageOptions={[8, 16, 50, 100]}
                responsiveLayout="scroll"
                emptyMessage={
                    <div className="text-center">

                        <img
                            src={require(
                                "../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg"
                            )}
                            style={{ width: "28%" }}
                            alt="Sin resultados"
                        />

                        <br />

                        <span>
                            No existen hospitalizaciones registradas
                        </span>

                    </div>
                }
            >

                <Column
                    header="#"
                    body={(row, { rowIndex }) => rowIndex + 1}
                    headerStyle={headerStyle}
                    style={{
                        ...centerStyle,
                        width: "60px"
                    }}
                />

                <Column
                    field="nim"
                    header="NIM"
                    sortable
                    headerStyle={headerStyle}
                    style={centerStyle}
                    body={(row) => row?.nim || "N/D"}
                />

                <Column
                    field="comment"
                    header="Motivo de hospitalización"
                    sortable
                    headerStyle={headerStyle}
                    style={{
                        ...cellStyle,
                        minWidth: "350px"
                    }}
                    body={commentBody}
                />

                <Column
                    field="created_at"
                    header="Fecha"
                    sortable
                    headerStyle={headerStyle}
                    style={centerStyle}
                    body={dateBody}
                />

            </DataTable>

        </Dialog>
    );
};